export default "__VITE_ASSET__58d66123__"